import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessRegularSurveys } from "@/components/ProjectSidebar/permissions";
import { canListAnySurvey } from "@/helpers/permissions";
import { canManageSurvey } from "@/modules/surveys/permissions";

import { RequireAuth } from "../../components/Routing/RequireAuth";
import { surveyRoutes } from "./routes";

export const surveysRoute = [
  {
    path: surveyRoutes.list,
    lazy: async () => {
      const { SurveysListPage } = await import("./pages/list/SurveysListPage");

      return {
        element: (
          <RequireAuth permission={canAccessRegularSurveys}>
            <SurveysListPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: surveyRoutes.new,
    lazy: async () => {
      const { CreateSurveyPage } = await import("./pages/create-or-edit/CreateSurveyPage");

      return {
        element: (
          <RequireAuth permission={canManageSurvey}>
            <CreateSurveyPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: surveyRoutes.edit,
    lazy: async () => {
      const { EditSurveyPage } = await import("./pages/create-or-edit/EditSurveyPage");

      return {
        element: (
          <RequireAuth permission={canManageSurvey}>
            <EditSurveyPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: surveyRoutes.details,
    lazy: async () => {
      const { SurveyDetailPage } = await import("./pages/details/SurveyDetailPage");

      return {
        element: (
          <RequireAuth permission={canListAnySurvey}>
            <SurveyDetailPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: surveyRoutes.respond,
    lazy: async () => {
      const { SurveyRespondPage } = await import("./pages/respond/SurveyRespondPage");

      return { element: <SurveyRespondPage /> };
    },
  },
  {
    path: surveyRoutes.fah,
    lazy: async () => {
      const { FeelingAtHomeDetailsPage } = await import("./pages/feeling-at-home-details/FeelingAtHomeDetailsPage");

      return {
        element: (
          <RequireAuth permission={canListAnySurvey}>
            <FeelingAtHomeDetailsPage />
          </RequireAuth>
        ),
      };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
